// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scrollbar-hide::-webkit-scrollbar {
  display: none;
}

/* For IE, Edge and Firefox */
.scrollbar-hide {
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
}

/* Agent notification styles */
.agent-notification {
    position: absolute;
    top: 45px;
    left: 0;
    right: 0;
    margin: 0 auto;
    background: rgb(29, 166, 76);
    color: white;
    padding: 5px 15px 8px;
    border-radius: 25px;
    /* box-shadow: 0 4px 15px rgba(29, 166, 76, 0.3); */
    z-index: 10000;
    animation: slideInRight 0.3s ease-out;
    font-size: 14px;
    font-weight: 500;
}

.agent-notification-content {
    display: flex;
    align-items: center;
    gap: 8px;
}

.agent-status-indicator {
    width: 8px;
    height: 8px;
    background-color: #fff;
    border-radius: 50%;
    animation: pulse 2s infinite;
}

@keyframes slideInRight {
    from {
        transform: translateX(100%);
        opacity: 0;
    }
    to {
        transform: translateX(0);
        opacity: 1;
    }
}

@keyframes pulse {
    0% {
        transform: scale(1);
        opacity: 1;
    }
    50% {
        transform: scale(1.2);
        opacity: 0.7;
    }
    100% {
        transform: scale(1);
        opacity: 1;
    }
}

/* Responsive design for mobile */
@media (max-width: 768px) {
    .agent-notification {
        top: 10px;
        right: 10px;
        left: 10px;
        text-align: center;
    }
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA,6BAA6B;AAC7B;EACE,wBAAwB,GAAG,gBAAgB;EAC3C,qBAAqB,GAAG,YAAY;AACtC;;AAEA,8BAA8B;AAC9B;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,cAAc;IACd,4BAA4B;IAC5B,YAAY;IACZ,qBAAqB;IACrB,mBAAmB;IACnB,mDAAmD;IACnD,cAAc;IACd,qCAAqC;IACrC,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,UAAU;IACV,WAAW;IACX,sBAAsB;IACtB,kBAAkB;IAClB,4BAA4B;AAChC;;AAEA;IACI;QACI,2BAA2B;QAC3B,UAAU;IACd;IACA;QACI,wBAAwB;QACxB,UAAU;IACd;AACJ;;AAEA;IACI;QACI,mBAAmB;QACnB,UAAU;IACd;IACA;QACI,qBAAqB;QACrB,YAAY;IAChB;IACA;QACI,mBAAmB;QACnB,UAAU;IACd;AACJ;;AAEA,iCAAiC;AACjC;IACI;QACI,SAAS;QACT,WAAW;QACX,UAAU;QACV,kBAAkB;IACtB;AACJ","sourcesContent":[".scrollbar-hide::-webkit-scrollbar {\n  display: none;\n}\n\n/* For IE, Edge and Firefox */\n.scrollbar-hide {\n  -ms-overflow-style: none;  /* IE and Edge */\n  scrollbar-width: none;  /* Firefox */\n}\n\n/* Agent notification styles */\n.agent-notification {\n    position: absolute;\n    top: 45px;\n    left: 0;\n    right: 0;\n    margin: 0 auto;\n    background: rgb(29, 166, 76);\n    color: white;\n    padding: 5px 15px 8px;\n    border-radius: 25px;\n    /* box-shadow: 0 4px 15px rgba(29, 166, 76, 0.3); */\n    z-index: 10000;\n    animation: slideInRight 0.3s ease-out;\n    font-size: 14px;\n    font-weight: 500;\n}\n\n.agent-notification-content {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.agent-status-indicator {\n    width: 8px;\n    height: 8px;\n    background-color: #fff;\n    border-radius: 50%;\n    animation: pulse 2s infinite;\n}\n\n@keyframes slideInRight {\n    from {\n        transform: translateX(100%);\n        opacity: 0;\n    }\n    to {\n        transform: translateX(0);\n        opacity: 1;\n    }\n}\n\n@keyframes pulse {\n    0% {\n        transform: scale(1);\n        opacity: 1;\n    }\n    50% {\n        transform: scale(1.2);\n        opacity: 0.7;\n    }\n    100% {\n        transform: scale(1);\n        opacity: 1;\n    }\n}\n\n/* Responsive design for mobile */\n@media (max-width: 768px) {\n    .agent-notification {\n        top: 10px;\n        right: 10px;\n        left: 10px;\n        text-align: center;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
